import type { ListResponseSessionLookUp, PriceOverrideStatus } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";

export const useSearchSessionsPriceOverrides = <TData = ListResponseSessionLookUp>(
  status?: Ref<Array<PriceOverrideStatus> | undefined>,
  sessionName?: Ref<string>,
  sessionId?: Ref<Array<string> | undefined>,
  useQueryOptions?: Partial<UseQueryOptions<ListResponseSessionLookUp, Error, TData>>,
) => {
  const fetchSearchSessionsPriceOverrides = async (): Promise<ListResponseSessionLookUp> => {
    return learningServiceRequest({
      method: "get",
      url: "/price_overrides/search/sessions/",
      params: {
        status: unref(status),
        session_name: unref(sessionName),
        session_id: unref(sessionId),
      },
    }).then((response: AxiosResponse<ListResponseSessionLookUp>) => response.data);
  };

  return useQuery<ListResponseSessionLookUp, Error, TData>({
    queryKey: computed(() => ["fetchSearchSessionsPriceOverrides", status, sessionName, sessionId]),
    queryFn: fetchSearchSessionsPriceOverrides,
    ...useQueryOptions,
  });
};
